import React from 'react';
import { EscalationDashboard } from './pages/EscalationDashboard';
export function App() {
  return <EscalationDashboard data-id="element-0" />;
}